import axios from 'axios';
import type { AxiosResponse } from 'axios';
import type { ReCaptchaInterface, ReCAPTCHAToken, SiteKey, ValidationOptions } from './ReCaptcha.d';

export default class ReCaptcha implements ReCaptchaInterface
{
    validateUrl: string = `${window._siteConfig.SITESMART_SITE_URL}@/Captcha/?action=verifyReCaptcha`;

    init(): ReCaptcha
    {
        const self: ReCaptcha = this;
        const forms = [
            {
                form: document.getElementById('newsletter-subscribe') as HTMLFormElement,
                siteKey: document.querySelector('#newsletter-subscribe [name=google-recaptcha]') as HTMLInputElement,
            },
            {
                form: document.getElementById('ecommerce-review-form') as HTMLFormElement,
                siteKey: document.querySelector('#ecommerce-review-form [name=google-recaptcha]') as HTMLInputElement,
            },
        ];

        for (const k in forms) {

            const item = forms[k];
            if (item?.form && item?.siteKey) {

                item.form.addEventListener('submit', function(e) {

                    e.preventDefault();

                    self.validateKey(item.siteKey?.value).then(token => {

                        self.validate(token, {

                            onSuccess: () => {

                                item.form.submit();

                            },
                            onFail: () => {

                                return false;

                            }

                        });

                    }).catch(e => {

                        console.error(e);
                        item.form.submit();

                    });

                    return false;
                });
            }
        }

        return this;
    }

    validate(token: ReCAPTCHAToken, opts: ValidationOptions): ReCaptcha
    {
        axios.post(this.validateUrl, { token }).then((r: AxiosResponse) => {

            if (r?.data?.success) {

                opts.onSuccess(r);

            } else {

                opts.onFail(r);

            }

        });

        return this;
    }

    validateKey(siteKey: SiteKey): Promise<ReCAPTCHAToken>
    {
        return new Promise((resolve, reject) => {

            window.grecaptcha.ready(function() {

                try {

                    window.grecaptcha.execute(siteKey, { action: 'submit' })
                        .then(function(token: ReCAPTCHAToken) {

                        return resolve(token);

                    });

                } catch (e) {

                    return reject(e);

                }

            });

        });
    }
}
